export default __webpack_public_path__ + "static/media/button-group-vs-dropdown-incorrect.69abdc4f.svg";